module.exports = __webpack_public_path__ + "img/Pfade_Tabea_10.2f5a5cce.png";